import styled from 'styled-components';
import { List, ListItemButton } from '@mui/material';

// CONSTANTS
import { rgba } from 'polished';

export const ListStyled = styled(List)`
  .nav-list,
  &.nav-list {
    &--nested {
      padding-top: 0;
      padding-bottom: 0;

      .MuiListItemButton-root {
        padding-left: 52px;
      }

      .nav-list--nested {
        .MuiListItemButton-root {
          padding-left: 69px;
        }
      }
    }
  }

  .MuiDivider-root {
    opacity: 0.8;
    margin: 0 20px;
  }
`;

export const ListItemStyled = styled(ListItemButton)`
  color: ${p => p.theme.palette.secondary.contrastText};

  span {
    font-size: 2.3rem;
    color: ${p => rgba(p.theme.palette.secondary.contrastText, 0.5)};
  }

  &.active {
    color: ${p => p.theme.palette.primary.contrastText};
    background-color: ${p => p.theme.palette.primary.main};

    span {
      color: ${p => p.theme.palette.primary.contrastText};
    }
  }

  &:hover {
    cursor: pointer;
    color: ${p => p.theme.palette.primary.contrastText};
    background-color: ${p => rgba(p.theme.palette.primary.main, 0.5)};

    span {
      color: ${p => p.theme.palette.primary.contrastText};
    }
  }
`;

export const CollapseIcon = styled.div`
  position: absolute;
  right: 0;
  width: 36px;
  color: ${p => rgba(p.theme.palette.secondary.contrastText, 0.5)};

  &:hover {
    color: ${p => p.theme.palette.primary.main};
  }
`;

export default CollapseIcon;
